import { InputNumber } from 'antd';

/**
 * Rupee input. Renders ₹ prefix and comma-groups on display; stores a plain
 * number (rupees, decimal-safe up to 2 places) — the API converts to paise
 * per rule M-*. `precision={2}` prevents float drift.
 *
 * Not used for paise-precision entry — this is the surface humans type at
 * (fee amounts, salary components, receipts). Payroll math that needs paise
 * arithmetic uses `@velora/core/measure` on the server, not this widget.
 */
interface Props {
  value?: number;
  onChange?: (value: number | null) => void;
  onBlur?: () => void;
  min?: number;
  max?: number;
  disabled?: boolean;
  autoFocus?: boolean;
  placeholder?: string;
  status?: 'error' | 'warning';
  id?: string;
}

export function MoneyField({ value, onChange, min = 0, max, ...rest }: Props) {
  return (
    <InputNumber
      value={value}
      onChange={(v) => onChange?.(typeof v === 'number' ? v : null)}
      min={min}
      max={max}
      precision={2}
      step={100}
      prefix="₹"
      formatter={(v) => {
        if (v === undefined || v === null) return '';
        const s = String(v);
        if (s === '') return '';
        const [whole = '', frac] = s.split('.');
        const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return frac !== undefined ? `${grouped}.${frac}` : grouped;
      }}
      parser={(v) => (v ? Number(v.replace(/[₹,\s]/g, '')) : 0) as unknown as number}
      style={{ width: '100%' }}
      {...rest}
    />
  );
}
